export const ESP_ROUTE = 'esp';
export const ESP_PAYMENT_PAGE = 'platnosc/:id';
export const ESP_PAYMENT_CONFIRMATION = 'potwierdzenie';
export const ESP_PAYMENT_CONFIRMATION_PARAMETRIZED = 'potwierdzenie/:id';
